import * as React from "react";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import "./TestTable.scss";

const MenuSelect = ({ panelId, onAddToWorkup,date }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleAddToWorkup = () => {
    handleClose();
    onAddToWorkup();
  };

  const options = ["View", "Add to workup"];
  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon className="more-icon" />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {options.map((option) =>
          option === "View" ? (
            <MenuItem
              key={option}
              selected={option === "Pyxis"}
              onClick={handleClose}
            >
              <Link
                className="view-link"
                to={`/view-test-results/${panelId}/${date}`}
                target="_blank"
              >
                {option}
              </Link>
            </MenuItem>
          ) : (
            <MenuItem
              key={option}
              selected={option === "Pyxis"}
              onClick={handleAddToWorkup}
            >
              {option}
            </MenuItem>
          )
        )}
      </Menu>
    </div>
  );
};

export default MenuSelect;
